import React from "react"

import { format } from "date-fns"
import { CalendarCheck, Check, RefreshCcw } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import { useApplication } from "@/contexts/ApplicationContext"

const OrientationConfirmation = () => {
  const { application } = useApplication()
  const navigate = useNavigate()
  const orientationDate = application.orientation.date
    ? new Date(application.orientation.date)
    : null

  const handleReschedule = () => {
    navigate("/orientation")
  }

  const handleContinue = () => {
    navigate("/orientation-quiz")
  }

  return (
    <div className="mx-auto max-w-md">
      <Card>
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="rounded-full bg-green-100 p-3">
              <CalendarCheck className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="mb-2 text-xl font-bold text-jungle">See You Soon!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2 rounded-lg bg-gray-50 p-4">
            <h3 className="mb-2 font-medium">Your Orientation Details</h3>
            {orientationDate && (
              <>
                <p className="text-sm">
                  <span className="font-medium">Date:</span>{" "}
                  {format(orientationDate, "EEEE, MMMM d, yyyy")}
                </p>
                <p className="text-sm">
                  <span className="font-medium">Time:</span> {format(orientationDate, "h:mm a")}
                </p>
              </>
            )}
            {console.log(application)}
            <p className="text-sm">
              <span className="font-medium">Location:</span>{" "}
              {application.orientation.location
                ? `${application.orientation.location}`
                : "HIVED Orientation Center"}
            </p>
          </div>
          <p className="text-center text-sm text-gray-600">
            We look forward to meeting you! Don't forget to bring your driving license and right to
            work documents.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col justify-center gap-2 pt-4">
          <div className="flex justify-center">
            <Button
              variant="outline"
              onClick={handleReschedule}
              className="flex items-center gap-2"
            >
              <RefreshCcw className="h-4 w-4" />
              Reschedule Orientation
            </Button>
          </div>
          <div className="flex justify-center">
            <Button variant="outline" onClick={handleContinue} className="flex items-center gap-2">
              <Check className="h-4 w-4" />I have attended orientation, Continue
            </Button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
}

export default OrientationConfirmation
